import { z } from 'zod';

// CT-3015 step 3. Added alongside submitTitleOwnerIncomeSchema (which stays for
// the live mutation). Differences from the old schema:
//   - `declaredIncome` is OPTIONAL: it was already persisted in step 1
//     (updateTitleSearchOwner). Omit it to reuse the stored value; provide it
//     (a number ≥ 0) to overwrite. An explicit null is rejected.
//   - adds per-owner `idMatrixReference` (required at the service layer for
//     PENSIONER owners verified via IDMATRIX).
//   - `isPensioner` is no longer an input — it is DERIVED from incomeType.
export const submitTitleSearchOwnerSchema = z
  .object({
    applicationId: z.string().min(1, 'applicationId is required'),
    // Not defaulted: an omitted value (undefined) must stay distinct from an
    // explicit `false` so the service only clears a prior dispute on explicit confirm.
    ownershipDisputed: z.boolean().optional(),
    owners: z
      .array(
        z.object({
          id: z.string().min(1, 'owner id is required'),
          declaredIncome: z
            .number()
            .finite('declaredIncome must be a finite number')
            .nonnegative('declaredIncome must be ≥ 0')
            .optional(),
          isIncomeVerified: z
            .literal(false)
            .nullish()
            .describe(
              'Optional. Only false is accepted (explicit skip / acknowledged unverified). The BE derives the true verdict server-side; submitting true is rejected.',
            ),
          idMatrixReference: z.string().min(1).nullish(),
          isSelfFundedRetireeDeclared: z.boolean().nullish(),
        }),
      )
      .default([]),
  })
  .superRefine((data, ctx) => {
    if (!data.ownershipDisputed && data.owners.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.too_small,
        minimum: 1,
        type: 'array',
        inclusive: true,
        message: 'At least one owner is required when ownership is not disputed',
        path: ['owners'],
      });
    }
  });
